module.exports = __webpack_public_path__ + "img/logo-dark-bg.82a11647.svg";